import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { PackingSlipItem } from '../../types';

interface PackingSlipItemsTableProps {
  items: PackingSlipItem[];
}

export function PackingSlipItemsTable({ items }: PackingSlipItemsTableProps) {
  if (items.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No items in this packing slip
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[60px]">Line</TableHead>
          <TableHead>SKU</TableHead>
          <TableHead>Description</TableHead>
          <TableHead className="text-right">Ordered</TableHead>
          <TableHead className="text-right">Packed</TableHead>
          <TableHead className="text-right">Backordered</TableHead>
          <TableHead>Lot #</TableHead>
          <TableHead>Serials</TableHead>
          <TableHead className="text-right">Pkg #</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell className="font-mono text-muted-foreground">
              {item.line_number}
            </TableCell>
            <TableCell className="font-mono font-medium">
              {item.sku_code}
            </TableCell>
            <TableCell>
              {item.sku_name || '—'}
            </TableCell>
            <TableCell className="text-right">
              {item.quantity_ordered}
            </TableCell>
            <TableCell className="text-right">
              <span className={item.quantity_packed < item.quantity_ordered ? 'text-orange-600' : 'text-green-600'}>
                {item.quantity_packed}
              </span>
            </TableCell>
            <TableCell className="text-right">
              {item.quantity_backordered > 0 ? (
                <span className="text-red-600">{item.quantity_backordered}</span>
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell>
              {item.lot_number || '—'}
            </TableCell>
            <TableCell>
              {item.serial_numbers && item.serial_numbers.length > 0 ? (
                <div className="flex flex-wrap gap-1">
                  {item.serial_numbers.slice(0, 3).map((sn, i) => (
                    <Badge key={i} variant="secondary" className="font-mono text-xs">
                      {sn}
                    </Badge>
                  ))}
                  {item.serial_numbers.length > 3 && (
                    <Badge variant="outline" className="text-xs">
                      +{item.serial_numbers.length - 3} more
                    </Badge>
                  )}
                </div>
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell className="text-right text-muted-foreground">
              {item.package_number || 1}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
